// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Tonga from '../_raw/flag/icon_flag_tonga.png';

export default () => <img src={Tonga} alt="Tonga" />;
